import type { PropType } from 'virtual-vue';
import type { DialogAction } from './dialog';

/**
 * Dialog 组件的 props
 */
export const props = {
  /**
   * 控制对话框是否显示
   * @default false
   */
  visible: {
    type: Boolean,
    default: false,
  },

  /**
   * 标题
   * @default ''
   */
  title: {
    type: String,
    default: '',
  },

  /**
   * 内容文本（支持html字符串方式传入）
   * @default ''
   */
  content: {
    type: String,
    default: '',
  },

  /**
   * 主题
   * @default 'normal'
   */
  theme: {
    type: String as PropType<'normal' | 'warn'>,
    default: 'normal',
    validator: (value: string) => ['normal', 'warn'].includes(value),
  },

  /**
   * 按钮配置
   * @default []
   */
  actions: {
    type: Array as PropType<DialogAction[]>,
    default: () => [],
  },

  /**
   * 多按钮排列方式
   * - 1个或3+个按钮：恒定为垂直布局，此属性不生效
   * - 2个按钮：默认水平布局，可设置为 'vertical' 切换为垂直布局
   * 注意：2个按钮水平布局时，第一个是辅助操作，第二个是主操作；
   *       2个按钮垂直布局时，第一个是主操作，第二个是辅助操作
   * @default undefined
   */
  buttonLayout: {
    type: String as PropType<'horizontal' | 'vertical'>,
    default: undefined,
    validator: (value: string) => ['horizontal', 'vertical'].includes(value),
  },

  /**
   * 指定挂载的 DOM 节点
   * @default 'body'
   */
  teleport: {
    type: String,
    default: 'body',
  },
};

